import {
	useInteractionMetrics,
	COLUMN_VISIBILITY_CHANGED,
	COLUMN_RESIZED,
	DND_ROW_DROPPED,
} from '../../../common/utils/interaction-metrics';

export const InteractionMetrics = () => {
	const interactionMetrics = useInteractionMetrics();

	if (interactionMetrics[COLUMN_RESIZED].state === 'started') {
		interactionMetrics[COLUMN_RESIZED].stop({ stopTime: Math.floor(performance.now()) });
	}

	if (interactionMetrics[COLUMN_VISIBILITY_CHANGED].state === 'started') {
		interactionMetrics[COLUMN_VISIBILITY_CHANGED].stop({
			stopTime: Math.floor(performance.now()),
		});
	}

	if (interactionMetrics[DND_ROW_DROPPED].state === 'started') {
		interactionMetrics[DND_ROW_DROPPED].stop({
			stopTime: Math.floor(performance.now()),
		});
	}

	return null;
};
